import customFetch from "../helpers/customFetch";
import { getConfigBasicAuth, URL_EXACTIAN } from "../helpers/helpers";

export const loginService = async (values) => {
    try {
        var configs = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify(values),
        };
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/Login`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const sendResetPasswordService = async (values) => {
    try {
        const configs = getConfigBasicAuth('POST', values);
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/PasswordRecovery`, configs)
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export const sendNewPasswordService = async (values) => {
    try {
        const configs = getConfigBasicAuth('PUT', values);
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/ChangePassword`, configs)
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export const logout = () => {
    window.location.pathname = ('/login');
    const removeItems = ['userData', 'settingMenu', 'accessOpening'];
    removeItems.forEach(el => {
        localStorage.removeItem(el);
    });
}

export const loginCCService = async (token) => {
    try {
        var configs = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            method: 'GET',
        };
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/Info`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const checkNewPasswordTokenService = async (user_name, password_auth) => {
    try {
        const configs = getConfigBasicAuth('GET');
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/ChangePassword?user_name=${user_name}&password_auth=${password_auth}`, configs)
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}